import { render, staticRenderFns } from "./download.vue?vue&type=template&id=3adf8a9b&scoped=true&lang=html&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&id=3adf8a9b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf8a9b",
  null
  
)

component.options.__file = "download.vue"
export default component.exports